// Electric Conductivity units with conversion factors to siemens per meter (S/m)
export const electricConductivityUnits = [
  { id: 'siemens-per-meter', name: 'Siemens per Meter', symbol: 'S/m', plural: 'Siemens per Meter', toBase: 1 },
  { id: 'siemens-per-centimeter', name: 'Siemens per Centimeter', symbol: 'S/cm', plural: 'Siemens per Centimeter', toBase: 100 },
  { id: 'millisiemens-per-meter', name: 'Millisiemens per Meter', symbol: 'mS/m', plural: 'Millisiemens per Meter', toBase: 0.001 },
  { id: 'millisiemens-per-centimeter', name: 'Millisiemens per Centimeter', symbol: 'mS/cm', plural: 'Millisiemens per Centimeter', toBase: 0.1 },
  { id: 'microsiemens-per-meter', name: 'Microsiemens per Meter', symbol: 'µS/m', plural: 'Microsiemens per Meter', toBase: 0.000001 },
  { id: 'microsiemens-per-centimeter', name: 'Microsiemens per Centimeter', symbol: 'µS/cm', plural: 'Microsiemens per Centimeter', toBase: 0.0001 },
  { id: 'mho-per-meter', name: 'Mho per Meter', symbol: 'mho/m', plural: 'Mhos per Meter', toBase: 1 },
  { id: 'mho-per-centimeter', name: 'Mho per Centimeter', symbol: 'mho/cm', plural: 'Mhos per Centimeter', toBase: 100 },
  { id: 'abmho-per-meter', name: 'Abmho per Meter', symbol: 'abmho/m', plural: 'Abmhos per Meter', toBase: 1e9 },
  { id: 'abmho-per-centimeter', name: 'Abmho per Centimeter', symbol: 'abmho/cm', plural: 'Abmhos per Centimeter', toBase: 1e11 },
  { id: 'statmho-per-meter', name: 'Statmho per Meter', symbol: 'statmho/m', plural: 'Statmhos per Meter', toBase: 1.11265e-12 },
  { id: 'statmho-per-centimeter', name: 'Statmho per Centimeter', symbol: 'statmho/cm', plural: 'Statmhos per Centimeter', toBase: 1.11265e-10 },
];

export const popularElectricConductivityConversions = [
  { from: 'siemens-per-meter', to: 'siemens-per-centimeter' },
  { from: 'siemens-per-centimeter', to: 'siemens-per-meter' },
  { from: 'siemens-per-meter', to: 'millisiemens-per-meter' },
  { from: 'millisiemens-per-centimeter', to: 'microsiemens-per-centimeter' },
  { from: 'microsiemens-per-centimeter', to: 'millisiemens-per-centimeter' },
  { from: 'mho-per-meter', to: 'mho-per-centimeter' },
];

export const getUnitById = (id) => electricConductivityUnits.find(unit => unit.id === id);

export const convertElectricConductivity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.toBase;
  return baseValue / toUnit.toBase;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert electric conductivity units and learn the conversion formula.`;
};
